export default "__VITE_ASSET__BKslY6OJ__"